import React, {memo} from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'
import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'

import {ReactComponent as ArrowIcon} from '../assets/images/icons/arrow.svg'
import igorAnanyImage from '../assets/images/blocks/igor-anany.png'
import igorAnanyImage2x from '../assets/images/blocks/igor-anany@2x.png'
import ScrollAnimation from './ScrollAnimation'
import './Mission.scss'

const StyledButton = withStyles({
  root: {
    height: 60,
    '@media (max-width: 1279px)': {
      height: 50
    }
  }
})(Button)

Mission.propTypes = {
  width: PropTypes.string.isRequired,
}

function Mission({width}) {
  const title = (
    <ScrollAnimation tag="h2" className="Mission-Title Title" effect="fadeInTop">
      Our mission
    </ScrollAnimation>
  )
  return (
    <ScrollableAnchor id="mission">
      <section className="Mission Container">
        <ArrowIcon className="Mission-Icon TranslateDownUp" />
        <Hidden smUp>
          <ScrollAnimation tag="p" className="Mission-MobileText" effect="fadeInBottom">
            Simple, intuitive, and elegant. Our websites are specifically created with premier tools and technology
            tailored to your business needs. Easy to maintain with technical support always available.
          </ScrollAnimation>
          {title}
        </Hidden>
        <Grid container spacing={2}>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
          <Grid item sm={5} lg={4}>
            <img
              className="Mission-Image"
              width={439}
              src={igorAnanyImage}
              srcSet={`${igorAnanyImage2x} 2x`}
              alt="Igor Anany"
            />
          </Grid>
          <Grid item xs={1} />
          <Grid item sm={6} lg={5}>
            <div className="Mission-Content">
              <Hidden xsDown>{title}</Hidden>
              <ScrollAnimation tag="p" className="Mission-Attention" effect="fadeInLeft">
                <b>
                  – support local
                  <br />
                  small businesses!
                </b>
              </ScrollAnimation>
              <ScrollAnimation tag="p" className="Mission-Text" effect="fadeInBottom">
                We are a team of awesome, inspired, creative people who enjoy what they do and take pride in their job.
                Every person in our team is an expert in their field. Our mission is to make the web a better place by
                making cost-effective, exceptional quality websites to push your brand ahead of your competitors. During
                the last five years, we developed a framework that allowed us to make our services affordable for
                everyone and accessible by everyone.
              </ScrollAnimation>
              <ScrollAnimation className="Mission-Block" effect="fadeInBottom">
                <p className="Mission-BlockText">
                  <strong>Igor Anany</strong>
                  <span className="Mission-Position">CEO of 7glyphs</span>
                </p>
                <StyledButton component="a" fullWidth={width === 'xs'} color="primary" variant="contained" href="https://7glyphs.com/" target="_blank">
                  Visit our main website
                </StyledButton>
              </ScrollAnimation>
            </div>
          </Grid>
          <Hidden mdDown>
            <Grid item xs={1} />
          </Hidden>
        </Grid>
      </section>
    </ScrollableAnchor>
  )
}

export default memo(Mission)
